"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FailedProcessing = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _FailedProcessing = require("./FailedProcessing.styled");
var _Button = require("../../Button/Button");
var FailedProcessing = exports.FailedProcessing = function FailedProcessing(_ref) {
  var onRetry = _ref.onRetry,
    _ref$canRetry = _ref.canRetry,
    canRetry = _ref$canRetry === void 0 ? true : _ref$canRetry,
    onSourceDeleted = _ref.onSourceDeleted;
  return /*#__PURE__*/_react["default"].createElement(_FailedProcessing.StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(_FailedProcessing.StyledMessageWrapper, null, /*#__PURE__*/_react["default"].createElement(_FailedProcessing.StyledErrorIcon, null, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faExclamationTriangle
  })), /*#__PURE__*/_react["default"].createElement(_FailedProcessing.TextContainer, null, /*#__PURE__*/_react["default"].createElement(_FailedProcessing.StyledStatusText, null, "Processing failed."), canRetry && /*#__PURE__*/_react["default"].createElement(_FailedProcessing.StyledLink, {
    onClick: onRetry
  }, "Retry"))), onSourceDeleted !== undefined && /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    onClick: onSourceDeleted,
    color: "danger",
    size: "small"
  }, "Delete"));
};
FailedProcessing.propTypes = {
  onRetry: _propTypes.func,
  canRetry: _propTypes.bool,
  onSourceDeleted: _propTypes.func
};